var _path, _path2, _path3, _path4, _path5, _g, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 203 145",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Phone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "call0",
    d: "m88.7 63.1l3.8-2.9c1-0.8 1.3-2.2 0.5-3.3l-15-22.3c-0.7-1.1-2.2-1.4-3.3-0.7l-9.4 5.6c-1.9 1.1-3.3 2.8-4 4.8 0.2-0.1 0.3-0.3 0.5-0.4 1-0.7 2.2-1.6 3.7-2.6 2.2-1.3 6.7-1 8.1 1.1l7.6 9.7 7.2 10.4c0 0.2 0.2 0.4 0.3 0.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "call0",
    d: "m115.8 116.7c2.6 0.9 7.3-0.1 8.8-1.9l0.5-0.6c-1.5 0.2-3 0-4.3-0.8l-1.2-0.7c-4.4-2.4-9.8-5.3-20.5-15.9-10.8-10.7-13.7-16-16.1-20.3l-0.7-1.2c-0.3-0.6-0.6-1.2-0.7-1.9-1.6 1.7-2.5 6.5-1.4 8.3 2.5 4.4 3.3 8.2 15.1 20.5 11.6 12.4 15.7 12.8 20.5 14.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "call0",
    d: "m161.8 117.7l-22.5-14.8c-1.1-0.7-2.5-0.5-3.3 0.5l-1.9 2.4c1.4-0.5 3-0.4 4.3 0.4l9.7 6.3 6.5 5.1c1.2 0.8 3 3.1 3.9 5.5 0.2 0.6 0.4 2.2 0.4 3.8l3.6-5.9c0.8-1.1 0.4-2.6-0.7-3.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "call1",
    d: "m118.9 59.2c11.3 0 20.4 9.2 20.4 20.4 0 1 0.8 1.9 1.9 1.9 1 0 1.9-0.8 1.9-1.9 0-13.3-10.8-24.1-24.1-24.1-1 0-1.9 0.8-1.9 1.9s0.7 1.8 1.8 1.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "call1",
    d: "m117.9 70.2c5.2 0 9.4 4.2 9.4 9.4 0 1 0.8 1.9 1.9 1.9s1.9-0.8 1.9-1.9c0-7.2-5.9-13.1-13.1-13.1-1 0-1.9 0.8-1.9 1.9-0.1 1 0.7 1.8 1.8 1.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(52)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "call2",
    d: "m5.7 6.8c-0.5 0-1 0.4-1 1v2.2c0 0.5 0.4 1 1 1s1-0.4 1-1v-2.2c-0.1-0.6-0.5-1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "call2",
    d: "m3.2 4.6h-2.2c-0.5 0-1 0.4-1 1s0.4 1 1 1h2.2c0.5 0 1-0.4 1-1s-0.5-1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "call2",
    d: "M5.7,0c-0.5,0-1,0.4-1,1v2.2c0,0.5,0.4,1,1,1s1-0.4,1-1V1C6.6,0.4,6.2,0,5.7,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "call2",
    d: "m10.4 4.4h-2.2c-0.5 0-1 0.4-1 1s0.4 1 1 1h2.2c0.5 0 1-0.4 1-1s-0.5-1-1-1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(184 98)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "call2",
    d: "m9.5 12c-0.8 0-1.5 0.7-1.5 1.6v3.8c0 0.9 0.7 1.6 1.5 1.6s1.5-0.7 1.5-1.6v-3.8c0-0.9-0.7-1.6-1.5-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "call2",
    d: "M5.4,8H1.6C0.7,8,0,8.7,0,9.5S0.7,11,1.6,11h3.8C6.3,11,7,10.3,7,9.5S6.3,8,5.4,8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "call2",
    d: "M9.5,0C8.7,0,8,0.7,8,1.6v3.8C8,6.3,8.7,7,9.5,7S11,6.3,11,5.4V1.6C11,0.7,10.3,0,9.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "call2",
    d: "M17.4,8h-3.8C12.7,8,12,8.7,12,9.5s0.7,1.5,1.6,1.5h3.8c0.9,0,1.6-0.7,1.6-1.5S18.3,8,17.4,8"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "call2",
    d: "m46.6 112s1.3 9.3-9.6 9.1c0 0 9.3 0.1 9.1 8.8 0 0 0.8-6.9 9.4-8.4 0 0-7.2 1.7-8.9-9.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "call3",
    d: "m174.6 37s1.3 9.3-9.6 9.1c0 0 9.3 0.1 9.1 8.8 0 0 0.8-6.9 9.4-8.4 0 0-7.2 1.7-8.9-9.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "call2",
    d: "m45.3 72s0.5 3.2-3.3 3.2c0 0 3.3 0 3.2 3.1 0 0 0.3-2.4 3.3-2.9 0-0.1-2.6 0.5-3.2-3.4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "call1",
    d: "m120 15c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm0-5c-1.1 0-2 0.9-2 2s0.9 2 2 2 2-0.9 2-2-0.9-2-2-2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "call1",
    d: "m108 145c-1.1 0-2-0.9-2-2s0.9-2 2-2 2 0.9 2 2-0.9 2-2 2zm0-3c-0.6 0-1 0.4-1 1s0.4 1 1 1 1-0.4 1-1-0.4-1-1-1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "call1",
    d: "M2.5,46C1.1,46,0,44.9,0,43.5S1.1,41,2.5,41S5,42.1,5,43.5S3.9,46,2.5,46z M2.5,42C1.7,42,1,42.7,1,43.5  S1.7,45,2.5,45S4,44.3,4,43.5S3.3,42,2.5,42z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "call1",
    d: "m164.3 114.1l-22.5-14.8c-3-2-7-1.3-9.2 1.5l-6.5 8.3c-0.7 1-2.1 1.2-3.1 0.7l-1.2-0.7c-4.1-2.2-9.2-5-19.5-15.2-10.5-10.3-13.3-15.4-15.5-19.4l-0.7-1.2c-0.6-1-0.3-2.4 0.6-3.1l8.4-6.5c2.8-2.2 3.5-6.2 1.5-9.2l-15-22.3c-2-3-6.1-3.9-9.3-2.1l-9.3 5.6c-3 1.8-5.2 4.6-6.2 8-1.1 4.2-1.4 8.5-0.9 12.8 0.5 4.2 1.6 8.3 3.1 12.2 3.1 7.7 7.3 14.9 12.4 21.5 0.3 0.4 2.2 2.6 4 4.8l0.5 0.6c0.8 0.9 2.1 1.1 3.1 0.4 0.5-0.4 0.8-0.9 0.8-1.4 0.1-0.6-0.1-1.1-0.5-1.6l-0.5-0.6c-1.1-1.3-3.6-4.3-3.9-4.7-4.9-6.3-8.9-13.2-11.8-20.5-1.4-3.6-2.4-7.3-2.8-11.2-0.4-3.8-0.2-7.5 0.8-11.2 0.7-2.3 2.2-4.2 4.2-5.4l9.4-5.6c1.1-0.7 2.6-0.4 3.3 0.7l15 22.3c0.7 1.1 0.5 2.5-0.5 3.3l-8.5 6.6c-2.7 2-3.5 5.8-1.8 8.7l0.7 1.2c2.4 4.3 5.3 9.7 16.1 20.3 10.8 10.7 16.2 13.6 20.5 15.9l1.2 0.7c2.9 1.6 6.7 0.9 8.8-1.8l6.5-8.3c0.8-1 2.3-1.2 3.3-0.5l22.5 14.8c1.1 0.7 1.4 2.2 0.8 3.3l-5.6 9.3c-1.2 2-3.1 3.5-5.4 4.2-11.3 3.1-31 0.5-61-29.2l-5.1-5.2c-0.8-0.9-2.2-0.9-3.1-0.1-0.4 0.4-0.7 0.9-0.7 1.5s0.2 1.2 0.6 1.6l5.2 5.3c21.1 20.9 40.1 31.4 56.5 31.4h0.1c2.9 0 5.8-0.4 8.7-1.1 3.4-0.9 6.3-3.1 8-6.1l5.6-9.3c1.9-3.2 1-7.2-2.1-9.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/Call_Icon.ef42bda23c4d84cbbf67b45bb2c3e60c.svg";
export { ForwardRef as ReactComponent };